import { createNavigation } from "next-intl/navigation";
import { locales, localePrefix, pathnames } from "./config";

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation({
    locales,
    localePrefix,
    pathnames,
  });
